export const isPrepayOrder = po => po?.isPrepay === true || Number(po?.isPrepay) === 1

export const canMarkPurchaseOrderPaid = po => isPrepayOrder(po) && po.purchaseOrderStatus === 'AWAITING_PREPAYMENT' && !po.prepaidAt

export const purchaseOrderStatusLabel = status =>
  ({
    NEW: 'Ny',
    AWAITING_PREPAYMENT: 'Afventer forudbetaling',
    SENT: 'På vej',
    PARTLY_RECEIVED: 'Delvist modtaget',
    RECEIVED: 'Modtaget',
    CLOSED: 'Lukket'
  }[status] || status)

export const receivedPurchaseOrderStatus = po => {
  const lines = po.purchaseOrderlines || []
  if (!lines.some(line => Number(line.amountReceived) > 0)) return po.purchaseOrderStatus
  return lines.every(line => Number(line.amountReceived || 0) >= Number(line.amountOfProducts)) ? 'RECEIVED' : 'PARTLY_RECEIVED'
}

export const validatePrepaymentSummary = response => {
  const rows = response?.summary
  if (
    !response ||
    response.error ||
    !Array.isArray(rows) ||
    !rows.every(
      row =>
        typeof row.currency === 'string' &&
        /^[A-Z]{3}$/.test(row.currency) &&
        typeof row.total === 'number' &&
        Number.isFinite(row.total) &&
        row.total >= 0 &&
        Number.isInteger(row.count) &&
        row.count >= 0
    ) ||
    new Set(rows.map(row => row.currency)).size !== rows.length
  ) {
    throw new Error('Invalid prepayment summary')
  }
  return rows
}
